import { getAssetUrl } from "@utils/getAssetUrl";
import type { ShareCampaignBuilder } from "../types";

// 圖片改版時更新此戳記破 LINE / CDN 快取（getAssetUrl 已帶 ?ver=，這裡再附加 &v=）
const HERO_IMAGE_REV = "20260525";
const heroImage = `${getAssetUrl(
	"/images/share/SummerSplash2026CampaignFlex/image_2.png",
)}&v=${HERO_IMAGE_REV}`;

// 點圖回到 Splash 2026 貼紙活動頁（LIFF 內 deep link）
const campaignUrl = `${process.env.REACT_APP_LIFF_URL ?? ""}/campaign/splash-2026`;

export const buildSummerSplash2026StickerFlex: ShareCampaignBuilder = () => {
	const text =
		"立即下載 Tory Burch Splash GIF 動態貼圖，收藏屬於這個夏日的玩趣片刻。";

	return [
		// 上：文字訊息
		{
			type: "text",
			text,
		},
		// 下：圖片（整張可點 → 回到貼紙活動頁）
		{
			type: "flex",
			altText: text,
			contents: {
				type: "bubble",
				size: "giga",
				// bubble 預設白底，PNG 任何透明邊或 fit 模式留白都會露出來；統一蓋成水色
				styles: {
					hero: {
						backgroundColor: "#A6D3D6",
					},
				},
				hero: {
					type: "image",
					url: heroImage,
					size: "full",
					// 原檔 1104×639，比例已對齊；用 cover 確保不會有縫隙留白
					aspectMode: "cover",
					aspectRatio: "1104:639",
					backgroundColor: "#A6D3D6",
					action: {
						type: "uri",
						label: "下載 Splash 貼圖",
						uri: campaignUrl,
					},
				},
			},
		},
	];
};
